import moment from "moment";
import "moment-timezone";

const timezone = "Asia/Kolkata";
const days = moment().tz(timezone).daysInMonth();
const currentDate = moment.tz(timezone).date();

export function calcDailyTarget(targetValue, targetAchieved) {
  try {
    const monthlyAmount = Number(targetValue || 0);
    const achievedAmount = Number(targetAchieved || 0);

    if (monthlyAmount <= achievedAmount) {
      return 0;
    }

    return ((monthlyAmount - achievedAmount) / days).toFixed();
  } catch (error) {
    console.log(error);
  }
}

export function calcDailyTarget2(targetValue, targetAchieved) {
  try {
    const monthlyAmount = Number(targetValue || 0);
    const achievedAmount = Number(targetAchieved || 0);
    const currentDate = moment().tz("Asia/Kolkata");
    const daysInMonth = currentDate.daysInMonth();
    const daysElapsed = currentDate.date();

    const remainingDays = daysInMonth - daysElapsed + 1;

    if (monthlyAmount <= achievedAmount) {
      return 0;
    }

    return ((monthlyAmount - achievedAmount) / remainingDays).toFixed();
  } catch (error) {
    console.log(error);
  }
}

export const remainingTarget = (targetValue, targetAchieved) => {
  const floatedTV = parseFloat(targetValue || 0);
  const floatedTA = parseFloat(targetAchieved || 0);

  if (floatedTA > floatedTV) {
    return 0;
  }

  const remaining = floatedTV - floatedTA;
  return parseFloat(remaining || 0).toFixed(2);
};

export const getLeadTypeByDate = (date) => {
  const currentDate = moment().tz("Asia/Kolkata");
  const targetDate = moment(date, "YYYY-MM-DD").tz("Asia/Kolkata");

  currentDate.startOf("day");
  targetDate.startOf("day");

  const differenceInDays = targetDate.diff(currentDate, "days");

  if (differenceInDays === 0) {
    return "hot";
  } else if (differenceInDays === 1) {
    return "semi hot";
  } else if (differenceInDays === 2) {
    return "warm";
  } else if (differenceInDays >= 3) {
    return "cold";
  } else {
    return "Status Not Updated";
  }
};

export const dailyTarget = (targetValue) => {
  const targetamount = Number(targetValue || 0);
  const total = Number(targetamount / days || 0);
  return total.toFixed();
};

export function getPassedDays() {
  return currentDate;
}

export const calDeficitAmount = (targetAmount, achievedTarget) => {
  const target = Number(targetAmount || 0);
  const achieved = Number(achievedTarget || 0);

  const daily_target = Number(dailyTarget(target) || 0);
  const upto_this_day = Number(daily_target * getPassedDays() || 0);

  // if (upto_this_day <= achievedTarget) {
  //   return 0;
  // }

  const deficit_amount = upto_this_day - achieved;
  return deficit_amount.toFixed();
};

export const calTodaysTarget = (targetAmount, achievedTarget) => {
  const target = Number(targetAmount || 0);
  const achieved = Number(achievedTarget || 0);

  const deficitAmount = Number(calDeficitAmount(target, achieved) || 0);
  // const daily = Number(dailyTarget(target) || 0);

  if (deficitAmount <= 0) {
    const dailyTargetCal = dailyTarget(target);
    return Number(dailyTargetCal || 0).toFixed();
  }

  // const total = Number(deficitAmount + daily || 0);
  const total = Number(deficitAmount || 0);

  return total.toFixed();
};

export const calIdeaTodaysTarget = (targetAmount) => {
  const target = Number(targetAmount || 0);
  const daily = Number(dailyTarget(target) || 0);

  const total = Number(daily * getPassedDays() || 0);

  return total.toFixed();
};
